// cry(추모관) FE 분해 Phase 1 (untangle) — cry 도메인 전용 상수.
// 추모관 별도 앱 추출 대비: cry(memorial/funeral/announcement/andersen) 상수를 ConstCode.js 에서 분리.
// ConstCode.js 는 이들을 re-export 하므로 기존 `import { CRY_TYPE } from '@/common/constants/ConstCode'` 는 그대로 동작.
// ⚠️ 순환/공유 주의로 순수 cry·자기완결(외부 store/computed·non-cry 상수 무참조) 세트만 이동.
//    소유분석 완료(260710): TICKET_MENU/GET_ITEM_TYPE/BACKGROUND_IMAGE=소비처 전부 cry라 이동.
//    ConstCode 잔류 확정(smile/user 겸용): FUNERAL_BUY_LIST·FUNERAL_EMOTICON_LIST·COMMENT_LIST·EMOTICON_MENU·AUDIO_FILES(common store).

export const CRY_USER_BACKGROUND_PASS = 'com.appg.lifeendlife.user_bgi';

export const CRY_TYPE = {
  MEMORIAL_IN: { key: 'MEMORIAL_IN', name: 'Inside' },
  MEMORIAL_OUT: { key: 'MEMORIAL_OUT', name: 'Outside' },
  ANDERSEN: { key: 'ANDERSEN', name: '안데르센' },
  ANNOUNCEMENT: { key: 'ANNOUNCEMENT', name: '온라인 부고장' },
  FUNERAL: { key: 'FUNERAL', name: '온라인 장례식장' }
};

export const MEMORIAL_TYPE = {
  OUTSIDE: 'Outside',
  INSIDE: 'Inside',
  ANDERSEN: 'ANDERSEN'
};

export const ANDERSEN_AUDIO_FILES = [
  '20250416 Piano (Hush, Little Baby).mp3',
  '20250416 Piano (Rock-a-Bye Baby).mp3',
  '20250416 Piano (고요한 밤 거룩한 밤).mp3',
  '20250416 Piano (반짝반짝 작은별).mp3',
  '20250416 Piano (브람스 자장가).mp3'
];

export const MEMORIAL_SEARCH_TYPE = {
  DEAD_NAME: {
    key: '고인 성함',
    value: 'DEAD_NAME'
  },
  NAME: {
    key: '가족 성함',
    value: 'NAME'
  },
  MEMORIAL_NO: {
    key: '등록 번호',
    value: 'MEMORIAL_NO'
  },
  CHURCH: {
    key: '등록 교회',
    value: 'CHURCH'
  }
};

export const MEMORIAL_TICKET_MENU = {
  SINGLE: '1인 추모관 이용권',
  MARRIED: '부부합장 추모관 이용권'
};

export const MEMORIAL_BACKGROUND_MENU = {
  BACKGROUND: '배경 이미지',
  PHOTO_FRAME: '액자 이미지'
};

export const SELECT_GNB_LIST = (callBack, url) => {
  return [
    {
      image: 'background05',
      content: `${MEMORIAL_TYPE.INSIDE} 추모관`,
      pushUrl: '/memorial/select',
      btnText: '입장하기',
      innerClass: 'widthFill height120',
      fnCallBack: () => {
        callBack(MEMORIAL_TYPE.INSIDE, url);
      }
    },
    {
      image: 'background06',
      content: `${MEMORIAL_TYPE.OUTSIDE} 추모관`,
      pushUrl: '/memorial/select',
      btnText: '입장하기',
      innerClass: 'widthFill height120',
      fnCallBack: () => {
        callBack(MEMORIAL_TYPE.OUTSIDE, url);
      }
    }
  ];
};

// MEMO: 가족제거 (생전모습)
export const MEMORIAL_GNB_LIST = (memorialNo, familyCode, userNo, historyCall) => {
  return [
    {
      content: '헌화하기',
      image: 'img-wreath',
      innerClass: 'widthFill height80 flex-justi-con-center',
      pushUrl: `/memorial/wreath/${memorialNo}`
    },
    {
      content: '생전모습',
      btnText: '입장하기',
      image: 'img-gallery',
      innerClass: 'onlineFuneral',
      pushUrl: `/memorial/alive/${memorialNo}`
    },
    {
      content: '우리가족 히스토리',
      btnText: '입장하기',
      image: 'img-familyHistory',
      innerClass: 'obituaries',
      pushUrl: `/memorial/history/${familyCode}`,
      fnCallBack: () => {
        historyCall();
      }
    }
  ];
};

export const CRY_RELATION_LIST = [
  '직접입력',
  '배우자',
  '부',
  '모',
  '아들',
  '딸',
  '며느리',
  '사위',
  '손자',
  '손녀',
  '외손자',
  '외손녀'
];

export const ANDERSEN_RELATION_LIST = ['직접입력', '부', '모'];

// (260710 소유분석 후 2차 이동 — 소비처 전부 cry)
// TICKET_MENU: components/common/modal/alert/memorial/TicketList.vue 단일 소비.
//   ⚠️ MEMORIAL_TICKET_MENU와 유사하나(SINGLE 동일·COUPLE vs MARRIED 상이) 동작보존 원칙으로 병합하지 않고 그대로 이동.
export const TICKET_MENU = {
  SINGLE: '1인 추모관 이용권',
  COUPLE: '부부합장 추모관 이용권'
};

// GET_ITEM_TYPE: views/memorial/register/step1.vue 단일 소비.
export const GET_ITEM_TYPE = {
  MEMORIAL: 'MEMORIAL'
};

// BACKGROUND_IMAGE: views/funeral/{index,detail}.vue + views/memorial/index.vue 소비(전부 cry).
export const BACKGROUND_IMAGE = {
  MAIN: 'bg-main',
  FUNERAL: 'bg-image02',
  FUNERAL_DETAIL: 'bg-image07',
  PHOTO: 'sample/bg-chatroom',
  MEMORIAL_INSIDE: 'bg-image01',
  MEMORIAL_OUTSIDE: 'bg-image04',
  MEMORIAL_HUMAN: 'sample/img-human',
  MEMORIAL_WOMAN: 'sample/img-woman',
  MEMORIAL_INSIDE_BACKGROUND: 'bg-image06',
  MEMORIAL_OUTSIDE_BACKGROUND: 'bg-image05'
};
